/* PreSleep bundle PDP: gallery, survey bars, review filter. Pricing + flavor picker live in ps-flavor-picker.js. */
(function () {
  if (window.__psBundle) return;
  window.__psBundle = true;

  function gallery(root) {
    var track = root.querySelector('[data-gal-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    var slides = track.children, dots = root.querySelectorAll('[data-gal-dot]'), cur = 0, raf = 0;
    function go(i, smooth) {
      var n = slides.length;
      i = (i + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark() {
      raf = 0;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === cur) return;
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(mark); }, { passive: true });
    root.querySelector('[data-gal-prev]').addEventListener('click', function () { go(cur - 1); });
    root.querySelector('[data-gal-next]').addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.galDot); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
  }

  function bars(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    if (!('IntersectionObserver' in window)) { el.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { el.classList.add('is-on'); io.disconnect(); }
    }, { threshold: 0.4 });
    io.observe(el);
  }

  function filter(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var max = +root.dataset.max || 4;
    var chips = root.querySelectorAll('[data-rf-chip]'), cards = root.querySelectorAll('[data-rf-tag]');
    function show(tag) {
      var shown = 0;
      cards.forEach(function (c) {
        var hit = !tag || c.dataset.rfTag === tag;
        var on = hit && shown < max;
        if (on) shown++;
        c.hidden = !on;
      });
      chips.forEach(function (ch) { var on = ch.dataset.rfChip === tag; ch.classList.toggle('is-on', on); ch.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    chips.forEach(function (ch) { ch.addEventListener('click', function () { show(ch.dataset.rfChip); }); });
  }

  function boot(scope) {
    scope.querySelectorAll('[data-ps-gal]').forEach(gallery);
    scope.querySelectorAll('[data-ps-bars]').forEach(bars);
    scope.querySelectorAll('[data-ps-rf]').forEach(filter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
